<template>
  <div>
    <b-modal
      id="updateAttractionTime"
      hide-footer
      centered
      v-model="isVisible"
      modal-class="modal-cover"
      content-class="shadow-lg"
      hide-backdrop
    >
      <div 
        v-if="attractionForChangeingTheDate"
        class="popup-header"
        :dir="isHebrew ? 'rtl' : 'ltr'">
        <form
          role="form"
          @submit.prevent="internalUpdateAttractionTimeAtRide"
          class="add_ride_form"
        >
          <h2 class="popup-title">{{ t('updateAttractionTitle') }}</h2>
          <h3 class="attraction-title" >{{ attractionForChangeingTheDate.title }}</h3>

          <span class="label">{{ t('updateAttractionDayLabel') }}</span>
          <datepicker
            class="input-uniform"
            name="attractionDate"
            v-model="updateAttractionDate"
            :disabled-dates="getCoulenderDates"
          ></datepicker>

          <span class="label">{{ t('updateAttractionTimeLabel') }}</span>
          <vue-timepicker
            format="hh:mm:ss A"
            name="attractionTime"
            v-model="updateAttractionTime"
            class="input-uniform"
          />

          <b-btn
            @click="internalUpdateAttractionTimeAtRide"
            pill
            variant="warning"
            class="py-3 px-5 text-white mt-4"
          >
            {{ t('updateAttractionSaveButton') }}
          </b-btn>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { translationMixin } from '@/mixins/translationMixin';
import Datepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import moment from "moment";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  props: ["value"],
  name: "UpdateAttractionTimePopUp",
  mixins: [translationMixin],
  components: {
    Datepicker,
    VueTimepicker,
  },
  computed: {
    ...mapGetters([
      "allRide",
      "newAttractionDateTime",
      "attractionForChangeingTheDate",
    ]),
    isVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    updateAttractionDate: {
      get() {
        return this.newAttractionDateTime;
      },
      set(value) {
        const rideFirstDay = new Date(value);
        this.$store.commit(
          "setNewAttractionDate",
          moment(rideFirstDay).format("M/D/YYYY")
        );
      },
    },
    updateAttractionTime: {
      get() {
        return this.newAttractionDateTime?.split(",")[1];
      },
      set(value) {
        this.$store.commit("setNewAttractionTime", value);
      },
    },
    getCoulenderDates: {
      get() {
        const startDate = moment(
          this.allRide.ride.start_date,
          "DD-MM-YYYY"
        ).toDate();
        const endDate = moment(
          this.allRide.ride.end_date,
          "DD-MM-YYYY"
        ).add(1, 'day').toDate();

        return {
          customPredictor(date) {
            return date < startDate || date > endDate;
          },
        };
      },
    },
  },
  methods: {
    ...mapActions(["updateAttractionTimeAtRide", "showModal"]),
    internalUpdateAttractionTimeAtRide() {
      this.updateAttractionTimeAtRide();
      this.showModal("");
    },
  },
};
</script>

<style scoped>

.popup-header {
  margin-bottom: 2rem;
}

.popup-title {
  font-size: 2.2rem;
  font-weight: bold;
  color: #333;
}

.attraction-title {
  font-size: 1.9rem;
  color: #2c7a7b;
  margin-bottom: 1rem;
  font-weight: 600;
}

.label{
  font-size: 1.8rem;
}

[dir="rtl"] .popup-header {
  text-align: right;
}

[dir="ltr"] .popup-header {
  text-align: left;
}

.poup_close_me:hover {
  background-color: #e2e6ea;
  transform: scale(1.05);
}
.input-uniform {
  width: 100%;
  max-width: 300px;
  font-size: 1.6rem;
  padding: 0.8rem 1rem;
  border: 1px solid #ddd;
  border-radius: 0.5rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  direction: ltr;
  margin-bottom: 1.5rem;
}

/* Specific fix for vue-timepicker input */
::v-deep .input-uniform input {
  font-size: 1.6rem;
  padding: 0.8rem 1rem;
  border: none;
  width: 100%;
  text-align: right;

}

.modal.modal-cover .modal-content,
.modal.modal-cover .modal-footer,
.modal.modal-cover .modal-header {
  border: none;
  align-items: stretch;
}

.poup_close_me {
  font-size: 3rem;
  height: 5rem;
  width: 5rem;
  top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  background-color: #d1d1d1;
  border: none;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.date_picker {
  text-align: right;
}

/* ✅ CUSTOM STYLING FOR vue2-timepicker */
::v-deep .custom-timepicker {
  font-size: 1.6rem;
  direction: ltr;
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  text-align: right;
}

::v-deep .custom-timepicker input {
  border: 1px solid #ddd;
  border-radius: 0.5rem;
  padding: 1rem;
  font-size: 1.6rem;
  width: 100%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

::v-deep .custom-timepicker .dropdown-menu {
  border-radius: 1rem;
  padding: 0.5rem;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

::v-deep .custom-timepicker .dropdown-item {
  font-size: 1.4rem;
  padding: 0.6rem 1rem;
  cursor: pointer;
}

::v-deep .custom-timepicker .dropdown-item:hover {
  background-color: #ffc107;
  color: #fff;
}
</style>
